// プロトタイプ埋め込みビュー（中身/TMS）。Pages Function から認証つきで取得し iframe で表示。
// 以前は public/prototypes/<slug>.html を静的配信していたが、実データが入ったまま
// ログインを通らずに読めていたため取りやめた（2026-08-24）。
// 段階統合の方針: まず既存プロトタイプを本体ナビに載せて“動く1アプリ”にし、順次 Firestore バインドへ差し替える。
import { prototypeUrl } from '../prototypeUrl.js'

function styleOnce() {
  if (document.getElementById('embed-style')) return
  const s = document.createElement('style')
  s.id = 'embed-style'
  s.textContent = `
  .embed{display:flex;flex-direction:column;height:calc(100vh - 96px);margin:-4px 0}
  .embed__bar{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:6px 2px 10px}
  .embed__note{font-size:12px;color:var(--text)}
  .embed__tag{display:inline-block;margin-left:6px;font-size:10.5px;color:var(--text);background:var(--head);border:1px solid var(--e1);border-radius:999px;padding:1px 8px;vertical-align:middle}
  .embed__open{font-size:12px;color:var(--text);text-decoration:none;background:var(--head);border:1px solid var(--e1);border-radius:8px;padding:6px 12px;white-space:nowrap}
  .embed__open:hover{background:var(--head)}
  .embed__frame{flex:1;width:100%;border:1px solid var(--e1);border-radius:12px;background:var(--card)}
  `
  document.head.appendChild(s)
}

export function makeEmbed(title, slug, note = '') {
  return function render(el) {
    styleOnce()
    el.innerHTML = `
      <section class="embed">
        <div class="embed__bar">
          <div class="embed__note">${note}<span class="embed__tag">プロトタイプ表示 → 順次データ連動</span></div>
          <button type="button" class="embed__open" data-prototype="${slug}">別タブで開く ↗</button>
        </div>
        <iframe class="embed__frame" title="${title}" loading="lazy"></iframe>
      </section>`
    // 取得はログイン後。失敗理由は画面に出す（黙って白いままにしない）
    const frame = el.querySelector('.embed__frame')
    prototypeUrl(slug)
      .then((url) => { frame.src = url })
      .catch((e) => {
        console.error(e)
        frame.replaceWith(Object.assign(document.createElement('div'), {
          className: 'embed__frame',
          style: 'display:flex;align-items:center;justify-content:center;color:var(--text);font-size:13px',
          textContent: e.message || '読み込みに失敗しました',
        }))
      })
  }
}
